import { IRolesTableSearchParam } from "../../../Interfaces/roleAndPermissionsInterfaces";
import TextInput from "../../../Components/TextInput";
import DynamicDropdown from "../../../Components/Dropdown/DynamicDropdown";
import { getPermissions } from "../../../Requests/roleAndPermissionsRequests";

interface IProps {
  searchParameters: IRolesTableSearchParam;
  nameInput: string;
  onNameChange: (value: string) => void;
  onChange: (name: string, value: any) => void;
}

const SearchParamUI = ({
  searchParameters,
  nameInput,
  onNameChange,
  onChange,
}: IProps) => {
  return (
    <div className="flex w-fit flex-row flex-wrap items-end justify-start gap-2">
      <div className="w-48">
        <TextInput
          label="نام نقش"
          name="name"
          onChange={(_, value) => onNameChange(value)}
          value={nameInput}
          autoComplete="off"
          extraLabel
        />
      </div>
      <div className="w-48">
        <DynamicDropdown
          dropdown={{
            name: "permissionId",
            placeholder: "سطح دسترسی",
            extraLabel: true,
          }}
          getData={getPermissions}
          onChange={onChange}
          value={searchParameters.permissionId}
        />
      </div>
    </div>
  );
};

export default SearchParamUI;
